module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (!_vm.isIcon && _vm.allModuleId > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showContainerModal(_vm.allModuleId)
      }
    }
  }, [_vm._v("Container Summary")]) : (_vm.isIcon && _vm.allModuleId > 0) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1 btn-action",
    attrs: {
      "size": "sm",
      "variant": "outline-dark",
      "title": "Container Summary"
    },
    on: {
      "click": function($event) {
        _vm.showContainerModal(_vm.allModuleId)
      }
    }
  }, [_c('i', {
    class: _vm.iconClass || 'fa fa-cube'
  })]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "Container-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.ContainerList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getJobContainerDetails', 'Export As Excel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnName) + "\n          "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.ContainerList,
      "fields": _vm.Containerfields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))]), _vm._v(" "), (row0.item.rollover_event_code == 1) ? _c('span', {
          class: {
            alert: true,
              'alert-danger-text': row0.item.rollover_event_code == 1,
              blink: row0.item.rollover_event_code == 1,
          }
        }, [_c('br'), _vm._v("This Container No Rollover")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "xs"
    },
    on: {
      "click": _vm.hideContainerModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4317721c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/moduleBasedContaierSummary.vue
// module id = 2563
// module chunks = 0